import React, { Fragment } from "react";
import { Table } from "reactstrap";
import { format } from "date-fns";
import { ReviewDetailsView } from "./reviewDetailsView";

export const ProcessedReports = (props) => {
  const { abuseReports, loading } = props;

  return (
    <Fragment>
      <div className="rounded px-3 px-sm-4 py-3 py-sm-5">
        <h1 className="display-3">Bereits bearbeitet</h1>
      </div>
      <Table>
        <thead>
          <tr>
            <th>Grund</th>
            <th>Genauerer Grund</th>
            <th>Content Titel</th>
            <th>Contributor</th>
            <th>ContentType</th>
            <th>gemeldet von</th>
            <th>Datum</th>
          </tr>
        </thead>
        {loading && <p>Loading</p>}
        <tbody>
          {abuseReports.map((report) => {
            return (
              <Fragment>
                <tr
                  id={"toggler" + report._id}
                  style={{ marginBottom: "10px" }}
                >
                  <td>{report.reason}</td>
                  <td>{report.subreason}</td>
                  <td>{report.contentTitle}</td>
                  <td>{report.contentContributor}</td>
                  <td>{report.contentType}</td>
                  <td style={{ fontWeight: "bold" }}>
                    {report.contributor.username}
                  </td>
                  <td>
                    {format(
                      new Date(parseInt(report.createdAt)),
                      "dd/MM/yyyy HH:mm",
                    )}
                  </td>
                </tr>
                <tr>
                  <td className={"p-0"} colSpan={7}>
                    {report.reviews.map((review) => {
                      return (
                        <ReviewDetailsView review={review} report={report} />
                      );
                    })}
                  </td>
                </tr>
              </Fragment>
            );
          })}
        </tbody>
      </Table>
    </Fragment>
  );
};
